import {
  CalendarAxis,
  CalendarAxisInput,
  CalendarEntry,
  CalendarEntryInput,
  CalendarEntryUpdate,
  CalendarHighlight,
  CalendarRangeData
} from '../models/calendar.model';
import {
  CalendarWeekTemplate,
  CalendarWeekTemplateItem,
  CalendarWeekTemplateItemInput
} from '../models/calendar-template.model';

export abstract class CalendarRepository {
  abstract loadRange(startDate: string, endDate: string): Promise<CalendarRangeData>;
  abstract loadPlanningRange(startDate: string, endDate: string): Promise<CalendarRangeData>;

  abstract createAxis(input: CalendarAxisInput): Promise<CalendarAxis>;
  abstract updateAxis(axisId: number, changes: Partial<CalendarAxisInput> & {
    isArchived?: boolean;
    archivedAt?: string | null;
  }): Promise<CalendarAxis>;

  abstract createEntry(input: CalendarEntryInput): Promise<CalendarEntry>;
  abstract updateEntry(entryId: number, input: CalendarEntryUpdate): Promise<CalendarEntry>;
  abstract setEntryPosition(entryId: number, position: number): Promise<void>;
  abstract completeEntry(entryId: number): Promise<void>;
  abstract reopenEntry(entryId: number): Promise<void>;
  abstract cancelEntry(entryId: number): Promise<void>;
  abstract deleteEntry(entryId: number): Promise<void>;

  abstract setHighlightTitle(date: string, title: string): Promise<CalendarHighlight>;
  abstract setHighlightEntry(date: string, entryId: number): Promise<CalendarHighlight>;
  abstract clearHighlight(date: string): Promise<void>;

  abstract loadWeekTemplates(): Promise<CalendarWeekTemplate[]>;
  abstract createWeekTemplate(name: string): Promise<CalendarWeekTemplate>;
  abstract createWeekTemplateFromWeek(name: string, weekStart: string): Promise<CalendarWeekTemplate>;
  abstract createWeekTemplateItem(
    templateId: number,
    input: CalendarWeekTemplateItemInput
  ): Promise<CalendarWeekTemplateItem>;
  abstract deleteWeekTemplateItem(itemId: number): Promise<void>;
  abstract deleteWeekTemplate(templateId: number): Promise<void>;
  abstract applyWeekTemplate(templateId: number, weekStart: string): Promise<number>;
}
